import {CircularProgress, IconButton, Paper, Toolbar, Tooltip} from '@mui/material';
import Typography from '@mui/material/Typography';
import {makeStyles} from '@mui/styles';
import React, {Fragment} from 'react';

const useStyles = makeStyles(() => ({
  title: {
    flexGrow: 1,
  }
}));

const Title = ({title, loading, controls, children}) => {
  const classes = useStyles();
  return (
    <Paper>
      <Toolbar>
        <Typography className={classes.title} component="h2" variant="h5">{title}</Typography>
        {children}
        {loading ? <CircularProgress/> : (controls ?? []).map((control, index) => {
          const button = <IconButton color="inherit" onClick={control.onClick}>{control.icon}</IconButton>;
          if (control.tooltip) {
            return <Tooltip key={index} title={control.tooltip}>{button}</Tooltip>;
          } else {
            return <Fragment key={index}>{button}</Fragment>;
          }
        })}
      </Toolbar>
    </Paper>
  );
};

export default Title;
